import { useEffect, useMemo, useState } from "react";
import { useCustomActions } from "../useCustomActions";
import { Heading } from "V2.0/common/heading";
import { CustomActionToggle } from "../components/CustomActionToggle";
import WhatsappTriggerCreate from "./WhatsappTriggerCreate";
import WhatsappTriggersTable from "./WhatsappTriggersTable";
import WhatsappTriggerEdit from "./WhatsappTriggerEdit";
import { CustomActionDelete } from "../components/CustomActionDelete";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

import { useWhatsappConfiguration } from "V2.0/HomePages/Integrations/Whatsapp/models/useWhatsappConfiguration";
import useMcubeEngageConfiguration from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/useMCubeEngageConfiguration";

export default function WhatsappTriggers(props) {
  const {
    customActions,
    syncAssistant,
    workspaceId,
    assistantId,
    assistants,
    whatsappTemplates,
    mcubeEngageTemplates,
    locked,
  } = props;
  const { customActionsArray, whatsAppTriggersEnabled } = customActions;
  const {
    removeCustomAction,
    createCustomAction,
    updateCustomAction,
    toggleCustomAction,
  } = useCustomActions({ syncAssistant, workspaceId, assistantId });

  const [openEdit, setOpenEdit] = useState({
    isOpen: false,
    item: null,
    index: null,
  });

  const [openDelete, setOpenDelete] = useState({
    isOpen: false,
    item: null,
    index: null,
  });

  const { whatsappConfiguration } = useWhatsappConfiguration(workspaceId);
  const { mcubeEngageConfiguration, isLoading, isConfigured } =
    useMcubeEngageConfiguration(workspaceId);

  const whatsappTriggers = useMemo(() => {
    if (customActionsArray.length > 0) {
      return customActionsArray.filter(
        (action) => action.actionFunction === "WHATSAPP",
      );
    }

    return [];
  }, [customActionsArray]);

  const handleItemDelete = (lifecycleCbs) => {
    removeCustomAction(openDelete.item._id, lifecycleCbs);
  };

  const handleItemEdit = (data, lifecycleCbs) => {
    updateCustomAction(data, openEdit.item._id, lifecycleCbs);
  };

  const handleToggleCustomAction = (state) => {
    const loadingMessage = state
      ? "Enabling WhatsApp Triggers.."
      : "Disabling WhatsApp Triggers..";
    const successMessage = state
      ? "WhatsApp Triggers enabled"
      : "WhatsApp Triggers disabled";

    const lifecycleCbs = {
      init: () => {
        message.loading(loadingMessage);
      },
      success: () => {
        message.destroy();
        message.success(successMessage);
      },
      error: (e) => {
        message.destroy();
        showErrorToast(e, "Failed to update WhatsApp Triggers");
      },
    };

    toggleCustomAction({ whatsAppTriggersEnabled: state }, lifecycleCbs);
  };

  return (
    <>
      <div className="min-w-[700px] m-4 flex flex-col gap-y-2 border rounded-lg">
        <div className="flex justify-between px-6 py-4 bg-gray-50 rounded-t-lg">
          <div className="flex gap-x-2 items-center">
            <p className="text-md font-semibold text-gray-900">
              WhatsApp Triggers
            </p>
            {!locked && (
              <CustomActionToggle
                isEnabled={whatsAppTriggersEnabled}
                onToggleCustomAction={handleToggleCustomAction}
              />
            )}
          </div>
          {!locked && (
            <WhatsappTriggerCreate
              onTriggerCreate={createCustomAction}
              assistants={assistants}
              whatsappTemplates={whatsappTemplates}
              whatsappConfiguration={whatsappConfiguration}
              mcubeEngageConfiguration={{
                data: mcubeEngageConfiguration,
                isLoading,
                isConfigured,
              }}
              mcubeEngageTemplates={mcubeEngageTemplates}
            />
          )}
        </div>
        <div className="min-h-96 px-4">
          <WhatsappTriggersTable
            whatsappTriggers={whatsappTriggers}
            onEdit={setOpenEdit}
            onDelete={setOpenDelete}
            showActions={!locked}
          />
        </div>
      </div>
      {openEdit.isOpen && !locked && (
        <WhatsappTriggerEdit
          open={true}
          onClose={() =>
            setOpenEdit({ isOpen: false, item: null, index: null })
          }
          assistants={assistants}
          whatsappTemplates={whatsappTemplates}
          onTriggerEdit={handleItemEdit}
          whatsappTrigger={openEdit.item}
          whatsappConfiguration={whatsappConfiguration}
          mcubeEngageTemplates={mcubeEngageTemplates}
          mcubeEngageConfiguration={{
            data: mcubeEngageConfiguration,
            isConfigured,
            isLoading,
          }}
        />
      )}
      {openDelete.isOpen && !locked && (
        <CustomActionDelete
          open={true}
          onClose={() =>
            setOpenDelete({ isOpen: false, item: null, index: null })
          }
          onDelete={handleItemDelete}
        />
      )}
    </>
  );
}
